import { IWithdraw } from "../../store/useCommunityWithdraws";
import { useDonations } from "../../store/useDonations";

export const WithdrawTable = () => {
  /** Hooks */
  const { userDonations } = useDonations();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Community
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {userDonations?.length
            ? userDonations.map((withdraw: IWithdraw) => (
                <tr
                  key={withdraw?._id}
                  className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
                >
                  <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                    {/* @ts-ignore */}
                    {withdraw?.community?.name}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {Number(
                      (withdraw?.amount ? withdraw?.amount / 100 : 0)?.toFixed(
                        2
                      )
                    )}{" "}
                    €
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
